export enum SignalStandardType {
  DTMF = 1,
  SCTE35 = 2,
  SCTE104 = 3,
  CuePeriod = 4,
}
